import { Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import PaymentVerificationLobby from '../components/PaymentVerificationLobby/PaymentVerificationLobby';
import PaymentVerificationPage from '../components/PaymentVerificationPage/PaymentVerificationPage';
import PaymentVerificationSummary from '../components/PaymentVerificationSummary/PaymentVerificationSummary';

const usePaymentVerificationWithdrawFlow = (): FlowConfig => {
  const paymentVerificationState = new Invoke(
    'paymentVerificationSave',
    PaymentVerificationSummary,
    PaymentVerificationPage
  );

  return [
    PaymentVerificationLobby,
    PaymentVerificationPage,
    paymentVerificationState,
    PaymentVerificationSummary
  ];
};

export default usePaymentVerificationWithdrawFlow;
